import { Text, colors } from '@khaddi/ui';
import type { ReactNode } from 'react';
import { View } from 'react-native';

export const TabHeader = ({ title, subtitle, right }: { title: string; subtitle?: string; right?: ReactNode }) => (
  <View style={{ paddingTop: 20, paddingHorizontal: 20, paddingBottom: 12, flexDirection: 'row', alignItems: 'flex-end', gap: 12 }}>
    <View style={{ flex: 1 }}>
      {subtitle ? <Text variant="caption">{subtitle}</Text> : null}
      <View accessibilityRole="header"><Text variant="display" style={{ fontSize: 26, lineHeight: 30, color: colors.text }}>
        {title}
      </Text></View>
    </View>
    {right}
  </View>
);
